import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import SecondaryMenu from '../../menu/secondaryMenu.component';
import Toggle from '../../shared/toggle/toggle.component';
import { reportingCurrencyCodeSelector, environmentSuffixSelector } from '../../shared/store/selectors';
import { hideDecimalsSelector, negativeMinusSelector, displayZeroSelector, shadeGridFlagSelector } from '../../userData/store/selectors';
import {
  changeBookType,
} from '../aggregationMenu/store/actions';
import {
  selectPeriodFrom,
  selectPeriodTo,
  selectSlGroupType,
  selectSlGroupItem,
  selectCountryTaxType,
  selectBookType,
  selectBookTypes,
  currencyToDisplaySelector,
  selectTaxYear,
} from '../aggregationMenu/store/selectors';
import {
  tbeErrorsSelector,
  isLoadingTbeErrorsSelector,
  tbeErrorObjSelector,
} from '../store/selectors';
import AggregationMenu from '../aggregationMenu/aggregationMenu.component';
import { OptionPropTypes } from '../aggregationMenu/propTypes';
import {
  reportDataIsDefined,
  reportDataChanged,
} from '../shared/report.utils';
import { findDirectTaxEntriesDelta } from '../shared/directEntries.helpers';
import { submitDirectTaxEntries } from '../store/actions';
import { fetchAccounts } from '../../shared/store/actions';
import GridReport from '../gridReport/gridReport.component';
import PendingSubmissions from '../gridReport/pendingSubmissions.component';
import { ReportDataPropTypes } from '../gridReport/propTypes';
import NavigationPrompt, {
  PENDING_ENTRIES_TITLE,
  PENDING_ENTRIES_MESSAGE,
} from '../../shared/navigationPrompt.component';
import { allCountryTaxes } from '../aggregationMenu/constants';
import { GROSS, NET, MULTIPLE_CURRENCIES } from '../shared/taxEntry.constants';
import { ColumnDefinitionsPropTypes } from '../../shared/propTypes/common';
import { ObligationPropTypes } from '../../administration/obligationsPage/propTypes';

import {
  fetchReportDataForViewDeferredRollforwardPage,
  exportToExcel,
  exportToCsv,
  onAggregationDroplistChange,
  updateEditedCell,
  revertEditedCells,
} from './store/actions';
import {
  reportDataSelector,
  isFetchingDeferredRollforwardReportSelector,
  isExportingDeferredRollforwardReportSelector,
  aggregationDroplistValueSelector,
  pendingSubmissionsCountSelector,
  columnDefinitionsSelector,
  obligationsSelector,
  periodOrCurrentSelector,
} from './store/selectors';
import {
  REPORT_DATA_KEYS,
} from './constants';

const US_FBOS = 'US FBOS';

class ViewDeferredRollforwardPage extends PureComponent {
  static propTypes = {
    countryTaxType: PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    }),
    periodFrom: PropTypes.shape({
      name: PropTypes.string.isRequired,
      taxYear: PropTypes.string.isRequired,
    }),
    periodTo: PropTypes.shape({
      name: PropTypes.string.isRequired,
      taxYear: PropTypes.string.isRequired,
    }),
    bookType: PropTypes.string.isRequired,
    bookTypes: PropTypes.arrayOf(PropTypes.string).isRequired,
    reportData: ReportDataPropTypes,
    pendingSubmissionsCount: PropTypes.number.isRequired,
    currencyToDisplay: PropTypes.string,
    slGroupType: OptionPropTypes,
    slGroupItem: OptionPropTypes,
    taxYear: OptionPropTypes,
    reportingCurrency: PropTypes.string,
    tbeErrorVal: OptionPropTypes,

    changeBookType: PropTypes.func.isRequired,
    fetchReportData: PropTypes.func.isRequired,

    isFetchingReportData: PropTypes.bool,
    isExportingReport: PropTypes.bool,

    exportToExcel: PropTypes.func.isRequired,
    exportToCsv: PropTypes.func.isRequired,

    hideDecimals: PropTypes.bool.isRequired,
    shouldDisplayZero: PropTypes.bool.isRequired,
    negativeMinus: PropTypes.bool.isRequired,
    onAggregationDroplistChange: PropTypes.func.isRequired,
    aggregationDroplistValue: PropTypes.string,
    environmentSuffix: PropTypes.string.isRequired,

    updateEditedCell: PropTypes.func.isRequired,
    revertEditedCells: PropTypes.func.isRequired,

    submitDirectTaxEntries: PropTypes.func.isRequired,
    fetchAccounts: PropTypes.func.isRequired,

    columnDefinitions: ColumnDefinitionsPropTypes,
    isRowShadingEnabled: PropTypes.bool.isRequired,
    obligations: PropTypes.arrayOf(ObligationPropTypes),
    period: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
  };

  state = {
    grossFlag: false,
  };

  componentDidMount() {
    if (this.reportDataIsDefined(this.props)) {
      this.fetchReportData();
    }

    this.props.fetchAccounts();
    this.updateExporters(this.columnDefinitions);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.reportDataIsDefined(prevProps) && this.reportDataChanged(prevProps, prevState)) {
      this.fetchReportData();
    }

    const isFBOSSelected = this.props.countryTaxType && prevProps.countryTaxType
      && (this.props.countryTaxType.label === US_FBOS
      && prevProps.countryTaxType.label !== US_FBOS);

    const isAllTaxTypesSelected = this.props.countryTaxType && prevProps.countryTaxType
      && (this.props.countryTaxType.label === allCountryTaxes.label
      && prevProps.countryTaxType.label !== allCountryTaxes.label);

    const shouldSwitchToNet = isFBOSSelected || isAllTaxTypesSelected;
    if (shouldSwitchToNet) {
      this.setState({
        grossFlag: false,
      });
    }

    const areColumnDefinitionsDifferent
      = this.props.columnDefinitions !== prevProps.columnDefinitions;

    if (areColumnDefinitionsDifferent) {
      this.updateExporters(this.props.columnDefinitions);
    }
  }

  updateExporters = columnDefinitions => {
    this.setState({
      exportToExcel: this.excelExporterFactory(columnDefinitions),
      exportToCsv: this.csvExporterFactory(columnDefinitions),
    });
  };

  reportDataIsDefined = () => reportDataIsDefined(REPORT_DATA_KEYS, this.props);
  reportDataChanged = (prevProps, prevState) =>
    reportDataChanged(REPORT_DATA_KEYS, prevProps, this.props)
    || prevState.grossFlag !== this.state.grossFlag;

  changeGrossFlag = value => {
    this.setState({ grossFlag: value });
  };

  fetchReportData = () => {
    const {
      periodFrom,
      periodTo,
      taxYear,
      slGroupType,
      slGroupItem,
      countryTaxType,
      bookType,
      bookTypes,
      fetchReportData,
      reportingCurrency,
      aggregationDroplistValue,
      tbeErrorVal,
      period,
    } = this.props;

    const { grossFlag } = this.state;

    fetchReportData({
      periodFrom,
      periodTo,
      taxYear,
      slGroupType,
      slGroupItem,
      countryTaxType,
      bookType,
      bookTypes,
      reportingCurrency,
      aggregateBy: aggregationDroplistValue,
      grossFlag,
      tbeErrorVal,
      currentPeriod: period.name,
    });
  };

  buildExportParams = columnDefs => {
    const {
      periodFrom,
      periodTo,
      taxYear,
      slGroupType,
      slGroupItem,
      countryTaxType,
      reportingCurrency,
      bookTypes,
      hideDecimals,
      shouldDisplayZero,
      negativeMinus,
      environmentSuffix,
      aggregationDroplistValue,
    } = this.props;

    const { grossFlag } = this.state;

    return {
      periodFrom,
      periodTo,
      taxYear,
      slGroupType,
      slGroupItem,
      countryTaxType,
      reportingCurrency,
      bookTypes,
      hideDecimals,
      shouldDisplayZero,
      negativeMinus,
      environmentSuffix,
      aggregateBy: aggregationDroplistValue,
      grossFlag,
      columnDefs,
    };
  };

  excelExporterFactory = columnDefs => () => {
    this.props.exportToExcel(this.buildExportParams(columnDefs));
  };

  csvExporterFactory = columnDefs => () => {
    this.props.exportToCsv(this.buildExportParams(columnDefs));
  };

  submitDirectTaxEntries = () => {
    const {
      slGroupItem,
      periodFrom,
      taxYear,
      countryTaxType,
      currencyToDisplay,
      bookType,
      obligations,
      reportData,
      submitDirectTaxEntries,
    } = this.props;

    const {
      grossFlag,
    } = this.state;

    const { rows } = reportData;

    let isEnabled = true;
    obligations.forEach(obligation => {
      if (obligation.companyCode === slGroupItem.value && obligation.countryTaxTypeDescription === countryTaxType.label && obligation.enabledFlag === 'N') {
        isEnabled = false;
      }
    });

    const directEntries = findDirectTaxEntriesDelta(
      rows,
      {
        slGroupItem,
        periodFrom,
        taxYear,
        countryTaxType,
        currencyToDisplay,
        bookType,
        grossFlag,
      }
    );

    submitDirectTaxEntries(
      directEntries,
      { callback: this.fetchReportData },
      isEnabled
    );
  };

  render() {
    const {
      slGroupType,
      slGroupItem,
      countryTaxType,
      bookType,
      reportData,
      pendingSubmissionsCount,
      currencyToDisplay,
      bookTypes,
      changeBookType,
      isFetchingReportData,
      isExportingReport,
      onAggregationDroplistChange,
      aggregationDroplistValue,
      updateEditedCell,
      revertEditedCells,
      columnDefinitions,
      isRowShadingEnabled,
      tbeErrorVal,
    } = this.props;

    const {
      grossFlag,
      exportToExcel,
      exportToCsv,
    } = this.state;

    const netGrossLabel = grossFlag ? GROSS : NET;

    const multipleCurrenciesWarning = currencyToDisplay === MULTIPLE_CURRENCIES
      ? 'The report contains multiple currencies. The report data will not be consistent.'
      : '';

    const label = countryTaxType && slGroupItem
      ? `Country Tax Type: ${countryTaxType.value}, ${slGroupType.label}: ${slGroupItem.label}, Currency: ${currencyToDisplay}, ${netGrossLabel}`
      : '';

    const unpostedJournalsInReport = reportData?.rows.some(
      row => Object.values(row).some(cell => cell.unpostedFlag === 'U')
    );
    const draftWarningMessage = unpostedJournalsInReport
      ? (
        <>
          <strong>DRAFT ONLY</strong>{` - Unposted Journals exist which will be removed from stated balances at rollforward.`}
        </>
      )
      : null;

    return (
      <div className="view-deferred-rollforward-page">
        <NavigationPrompt
          show={pendingSubmissionsCount > 0}
          title={PENDING_ENTRIES_TITLE}
          message={PENDING_ENTRIES_MESSAGE}
        />
        <SecondaryMenu>
          <AggregationMenu
            exportToExcel={exportToExcel}
            exportToCsv={exportToCsv}
            isExportingReport={isExportingReport}
            withTaxYearSelector
            aggregationDropList={{
              onChange: onAggregationDroplistChange,
              value: aggregationDroplistValue,
            }}
            includeFbosCTT
          />
        </SecondaryMenu>
        <div className="page">
          <div className="container-fluid page-content-container">
            <div className="row no-gutters">
              <div className="col">
                {(!countryTaxType || !bookTypes.length || !slGroupItem)
                  ? null
                  : <GridReport
                    isRowShadingEnabled={isRowShadingEnabled}
                    bookType={bookType}
                    bookTypes={bookTypes || []}
                    countryTaxType={countryTaxType}
                    selectBookType={changeBookType}
                    chosenValuesText={label}
                    tbeErrorWarning={tbeErrorVal.tbeError}
                    multipleCurrenciesWarning={multipleCurrenciesWarning}
                    columnDefinitions={columnDefinitions}
                    reportData={reportData && reportData.rows}
                    pinnedTopRowData={reportData && reportData.pinnedRows}
                    reportTitle="Deferred Rollforward"
                    isFetchingReportData={isFetchingReportData}
                    isLoading={isFetchingReportData}
                    onCellValueChanged={updateEditedCell}
                    warningMessage={draftWarningMessage}
                    elementToRenderNextToPills={(
                      <div className="view-deferred-rollforward-page__toggle-container">
                        <Toggle
                          onChange={this.changeGrossFlag}
                          checked={grossFlag}
                          labelOff="Net"
                          labelOn="Gross"
                        />
                        <PendingSubmissions
                          entriesCount={pendingSubmissionsCount}
                          revertEditedCells={revertEditedCells}
                          submitEditedCells={this.submitDirectTaxEntries}
                        />
                      </div>
                    )}
                  />
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state, props) {
  return {
    periodFrom: selectPeriodFrom(state),
    periodTo: selectPeriodTo(state),
    slGroupType: selectSlGroupType(state),
    slGroupItem: selectSlGroupItem(state),
    tbeErrors: tbeErrorsSelector(state),
    countryTaxType: selectCountryTaxType(state),
    bookType: selectBookType(state),
    bookTypes: selectBookTypes(state),
    reportData: reportDataSelector(state),
    tbeErrorVal: tbeErrorObjSelector(state),
    pendingSubmissionsCount: pendingSubmissionsCountSelector(state),
    taxYear: selectTaxYear(state),
    reportingCurrency: reportingCurrencyCodeSelector(state),
    isFetchingReportData: isFetchingDeferredRollforwardReportSelector(state),
    isLoadingTbeErrors: isLoadingTbeErrorsSelector(state),
    isExportingReport: isExportingDeferredRollforwardReportSelector(state),
    currencyToDisplay: currencyToDisplaySelector(state),
    shouldDisplayZero: displayZeroSelector(state),
    hideDecimals: hideDecimalsSelector(state),
    negativeMinus: negativeMinusSelector(state),
    aggregationDroplistValue: aggregationDroplistValueSelector(state),
    /* isClientLocked prop is passed to selectors, because there is a logic placed */
    columnDefinitions: columnDefinitionsSelector({ ...state, props: { isClientLocked: props.isClientLocked } }),
    environmentSuffix: environmentSuffixSelector(state),
    isRowShadingEnabled: shadeGridFlagSelector(state),
    obligations: obligationsSelector(state),
    period: periodOrCurrentSelector(state),
  };
}

const ViewDeferredRollforwardPageConnected = connect(
  mapStateToProps,
  {
    changeBookType,
    fetchReportData: fetchReportDataForViewDeferredRollforwardPage,
    exportToExcel,
    exportToCsv,
    onAggregationDroplistChange,
    updateEditedCell,
    revertEditedCells,
    submitDirectTaxEntries,
    fetchAccounts,
  }
)(ViewDeferredRollforwardPage);

ViewDeferredRollforwardPageConnected.propTypes = {
  isClientLocked: PropTypes.bool.isRequired,
};

export default ViewDeferredRollforwardPageConnected;
